
export class ColorMap {

    private readonly colors: [number, number, number][] = [];
    private readonly colorMapMin: number;
    private colorMapMax: number;
    private readonly colorMapWidth: number;

    constructor(min: number, max: number, colors: [number, number, number][]) {
        this.colors = colors;
        this.colorMapMin = min;
        this.colorMapMax = max;
        this.colorMapWidth = max - min;
    }

    static fromValueList(values: number[], colors: [number, number, number][]): ColorMap {
        const min = Math.min(...values);
        const max = Math.max(...values);
        return new ColorMap(min, max, colors);
    }

    interpolateColor(value: number): string {
        if (value == null || isNaN(value) || this.colorMapWidth === 0) return 'transparent';

        const v = ColorMap.clampZeroOne((value - this.colorMapMin) / this.colorMapWidth);
        const sections = this.colors.length - 1;
        const vOnLen = v * sections;
        const index = Math.min(Math.floor(vOnLen), sections - 1);
        const color1 = this.colors[index];
        const color2 = this.colors[index + 1];

        // Calculate the weight for the interpolation
        const weight = vOnLen - index;

        // Interpolate between the two colors
        const weightComplement = 1 - weight;
        const rV = ColorMap.clampZeroOne(color1[0] * weightComplement + color2[0] * weight);
        const gV = ColorMap.clampZeroOne(color1[1] * weightComplement + color2[1] * weight);
        const bV = ColorMap.clampZeroOne(color1[2] * weightComplement + color2[2] * weight);

        const r = Math.round(rV * 255);
        const g = Math.round(gV * 255);
        const b = Math.round(bV * 255);

        return '#' + r.toString(16).padStart(2, '0') + g.toString(16).padStart(2, '0') + b.toString(16).padStart(2, '0');
    }

    // Determine which two colors to interpolate between
    private static clampZeroOne(v: number): number {
        return Math.max(0, Math.min(1, v));
    }


    static hexToRgbFloat(hex: string): [number, number, number] {
        // Remove the '#' from the start of the hex color if it exists
        if (hex.charAt(0) === '#') {
            hex = hex.substr(1);
        }

        // Convert the hex color to a decimal RGB color
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);

        // Convert each component of the RGB color to a float
        return [r / 255, g / 255, b / 255];
    }

    public static LRColors = [
        ColorMap.hexToRgbFloat('#90EE90'),
        ColorMap.hexToRgbFloat('#FFFF00'),
        ColorMap.hexToRgbFloat('#FFD700'),
        ColorMap.hexToRgbFloat('#FF6347')
    ];

    public static ThreePointMap = [
        ColorMap.hexToRgbFloat('#f8696b'),
        ColorMap.hexToRgbFloat('#ffeb84'),
        ColorMap.hexToRgbFloat('#63be7b')
    ];

    public static ZeroToOneHeatMap =  new ColorMap(0, 1, ColorMap.ThreePointMap);
}
